import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import SingleValueCard from '../../components/SingleValueCard/SingleValueCard';
import { MobileSize } from '../../admin/DashboardPage/ScorecardContainer/ScorecardContainer';
import { getReportPageKPICardsOuterBoxSx } from '../../lib/styles/commonStyles';
import { GetScheduledReportsResponse } from '../../admin/requests/index';

interface ScheduledReportsCountCardsProps {
  scheduledReportsData: GetScheduledReportsResponse | undefined;
  isLoading: boolean;
}

function ScheduledReportsCountCards({ scheduledReportsData, isLoading }: Readonly<ScheduledReportsCountCardsProps>) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(1024));

  const cardConfigs = [
    {
      title: t('admin.scheduledReports.countCards.totalReports'),
      value: scheduledReportsData?.total,
      testId: 'total-reports-count',
    },
    {
      title: t('admin.scheduledReports.countCards.scheduledByYou'),
      value: scheduledReportsData?.scheduledByYou,
      testId: 'scheduled-by-you-count',
    },
    {
      title: t('admin.scheduledReports.countCards.sentToYou'),
      value: scheduledReportsData?.scheduledToYou,
      testId: 'sent-to-you-count',
    },
  ];

  const cardProps = {
    width: isMobile ? '100%' : 'calc((100% - 20px)/3)',
    height: '174px',
    mobileSize: 'small' as MobileSize,
    currency: false,
    percentage: false,
  };

  return (
    <Box sx={getReportPageKPICardsOuterBoxSx(isMobile)} data-testid='scheduled-reports-count-cards'>
      {cardConfigs.map((config) => (
        <SingleValueCard
          key={config.testId}
          title={config.title}
          value={config.value?.toString() ?? '0'}
          loading={isLoading}
          testId={config.testId}
          {...cardProps}
        />
      ))}
    </Box>
  );
}

export default ScheduledReportsCountCards;
